import React from 'react';
import { useFormContext } from 'react-hook-form/dist/index.ie11';
import { CookbookNumericFormatInputWrapper } from 'src/components/CookbookNumericFormatInputWrapper/CookbookNumericFormatInputWrapper';

export interface SalesPersonIDProps {
  name: string;
  id: string;
}

export function SalesPersonID({ name, id }: SalesPersonIDProps): JSX.Element {
  const { errors, control } = useFormContext();

  return (
    <CookbookNumericFormatInputWrapper
      name={name}
      id={id}
      maxLength={5}
      control={control}
      error={errors[name]}
      inputSize="medium"
      allowNegative={false}
      blockWidth
      label="Sales Person ID *"
      placeholder="e.g. 123456"
      groupingSeparator=""
      rules={{
        required: 'Sales Person ID is required',
        min: { value: 1, message: 'Sales Person ID is invalid' },
      }}
    />
  );
}
